"use client";

import { useState, useEffect, useRef } from "react";
import "./CaseStudies.css";
import citeaPic from "../assets/cites mockup.png";
import bytkey from "../assets/Bytkey.png";
import simpli from "../assets/simpli projects.png";
import vox from "../assets/thumbnail vox works.png";
import dgree from "../assets/batch-degree.png";
const caseStudies = [
  {
    id: 1,
    title: "Voxworks - AI Calling Dashboard for Real Estate",
    description:
      "To simplify how agents connect with property leads through smart, scalable AI calling. ",
    image: vox,
    link: "https://www.notion.so/awesomaa1/Voxworks-AI-Calling-Dashboard-for-Real-Estate-21a44606a6a9809d9e44effb1b7c2488",
  },
  {
    id: 2,
    title: "Bytekey Fintech App",
    description:
      "BytKey is a modern financial app designed to eliminate the inefficiencies of traditional banking for individuals and businesses.",
    image: bytkey,
    link: "https://www.notion.so/awesomaa1/Bytekey-Fintech-App-1f044606a6a9803c9ac2cd76d2deb34b",
  },
  {
    id: 3,
    title: "Simpliprojects Project Management Tool",
    description:
      "The Construction Project Management System unifiesDashboard , Projects ,Requests , Chat , and Contacts into one platform.",
    image: simpli,
    link: "https://www.notion.so/awesomaa1/Simpli-Projects-Construction-Projects-Centralized-Automated-1ac44606a6a9807b9fa6c5f22c2fe851",
  },
  {
    id: 4,
    title: "Citea Small Business Management",
    description:
      "Citea is a comprehensive business management tooldesigned for small business owners, specifically barbersand salon owners, to efficiently manage appointments, ",
    image: citeaPic,
    link: "https://www.notion.so/awesomaa1/Citea-Small-Business-Management-19544606a6a980068bf9f7d0ac60d7b6",
  },
  {
    id: 5,
    title: "University Digital Degree Management System",
    description:
      "A customizable certificate generation system designed to simplify and scale degree issuance for universities.",
    image: dgree,
    link: "https://www.notion.so/awesomaa1/University-Digital-Degree-Management-System-20e44606a6a98042a6a1e3752f0e5594",
  },
];

const CaseStudies = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleItems, setVisibleItems] = useState(3);
  const [expanded, setExpanded] = useState(false);
  const sliderRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 576) {
        setVisibleItems(1);
      } else if (window.innerWidth < 992) {
        setVisibleItems(2);
      } else {
        setVisibleItems(3);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const nextSlide = () => {
    if (currentIndex === 0 && !expanded) {
      // First click on right arrow from initial state
      setExpanded(true);
      return;
    }

    setCurrentIndex((prevIndex) => {
      const nextIndex = prevIndex + 1;
      return nextIndex >= caseStudies.length - visibleItems + 1 ? 0 : nextIndex;
    });
  };

  const prevSlide = () => {
    if (currentIndex === 0 && expanded) {
      // Click on left arrow to return to initial state
      setExpanded(false);
      return;
    }

    setCurrentIndex((prevIndex) => {
      const nextIndex = prevIndex - 1;
      return nextIndex < 0 ? caseStudies.length - visibleItems : nextIndex;
    });
  };

  return (
    <section id="work" className="case-studies">
      <div className="container">
        <div className={`case-studies-content ${expanded ? "expanded" : ""}`}>
          <div className="case-studies-heading">
            <h2 className="section-title">
              <span className="case-text text-orange">CASE</span>
              <span className="case-text text-white">STUDIES</span>
            </h2>
          </div>

          <div className="slider-container">
            <div className="slider-wrapper" ref={sliderRef}>
              <div
                className="slider"
                style={{
                  transform: `translateX(-${currentIndex * (100 / visibleItems)
                    }%)`,
                  width: `${(caseStudies.length / visibleItems) * 100}%`,
                }}
              >
                {caseStudies.map((study) => (
                  <div
                    key={study.id}
                    className="case-study-item"
                    style={{ width: `384px` }}
                  >
                    <div className="case-study-card">
                      <div className="case-study-image">
                        <img
                          src={study.image || "/placeholder.svg"}
                          alt={study.title}
                        />
                      </div>
                      <div className="case-study-content">
                        <h3>{study.title}</h3>
                        <p>{study.description}</p>
                        <a href={study.link} className="case-study-link">
                          View Case Study
                          <span className="arrow-icon">→</span>
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Show left button only when expanded */}
            {expanded && (
              <button className="slider-btn prev-btn" onClick={prevSlide}>
                &#8249;
              </button>
            )}

            <button className="slider-btn next-btn" onClick={nextSlide}>
              &#8250;
            </button>
          </div>
        </div>

        <div className="view-all-container">
          <a
            href="https://www.notion.so/awesomaa1/26619b6220a24477a13e68c673dd3115?v=c15da87066c44bbb949546b5b3d4dcf8"
            target="_blank"
            className="btn btn-primary"
          >
            SEE MORE
          </a>
        </div>
      </div>
    </section>
  );
};

export default CaseStudies;
